import $ from 'jquery';
import widgetFactory from '../widgetFactory';

const widgetName = 'ajaxedForm';
const baseClassname = `js-${widgetName}`;

export const TARGET_MUST_BE_A_FORM_EXCEPTION = 'the targeted element must be a <form>.';

export default widgetFactory(widgetName, {
  options: {
    onBeforeRequest: $.noop,
    onSuccess: $.noop,
    onError: $.noop,
  },

  _create() {
    this._super(baseClassname);

    if (!this.element.is('form')) {
      throw new Error(TARGET_MUST_BE_A_FORM_EXCEPTION);
    }

    this._promise = null;
    this.elements.$form = this.element;
    this._attachEvents();
  },

  _attachEvents() {
    this.elements.$form.on('submit', (e) => {
      e.preventDefault();
      this.submitForm();
    });
  },

  /**
   *
   * @returns {Promise}
   */
  submitForm() {
    const $form = this.elements.$form;

    if (!this._promise && this._trigger('onBeforeRequest')) {
      this._promise = new Promise((resolve, reject) => {
        $.ajax({
          type: $form.attr('method') || 'post',
          url: $form.attr('action'),
          data: $form.serialize(),
        })
          .always(() => {
            this._promise = null;
          })
          .then(
            (data) => {
              this._trigger('onSuccess', null, data);
              resolve();
            },
            () => {
              this._trigger('onError');
              reject();
            }
          );
      });
    }

    return this._promise;
  },
});
